import { PageType } from './types'

const transformCompanyName = (company: string): string => {
	return company.toLowerCase().replace(/\s+/g, '-')
}

export const getNavigationPath = (pageType: PageType, ticker: string, company: string): string => {
	const lowerTicker = ticker.toLowerCase()

	// Handle decoder pages
	if (['other', 'summary', 'earnings', 'metrics', 'dynamics', 'statements'].includes(pageType)) {
		return `/decoder/navigator/${lowerTicker}/${pageType}`
	}

	// Handle herdpower pages
	if (pageType === 'herdpower') {
		return `/herd/${pageType}/${ticker}`
	}

	if (pageType === 'news') {
		return `/news/${ticker}`
	}

	if (pageType === 'feature') {
		const transformedCompany = transformCompanyName(company)

		// Handle special herd pages
		if (['herd-pulse', 'trending', 'herdpower'].includes(transformedCompany)) {
			return `/herd/${transformedCompany}`
		}

		// Handle special decoder pages
		if (['sifter', 'navigator'].includes(transformedCompany)) {
			return `/decoder/${transformedCompany}`
		}

		// Default feature path
		return `/${transformedCompany}`
	}

	if (pageType === 'bot') {
		return `/mavbots-arena`
	}

	// Handle all other pages
	return `/${pageType}/${ticker}`
}
